import React from 'react'
import {toAbsoluteUrl} from "../../../../_metronic/helpers";
import {useThemeMode} from "../../../../_metronic/partials";
import {ThemeModeComponent} from "../../../../_metronic/assets/ts/layout";

type AuthorProps = {
  name?: string
  href?: string
  imagePath?: string
}

const systemMode = ThemeModeComponent.getSystemMode() as 'light' | 'dark'


export const Author = ({
                         imagePath = '/media/features-logos/felix-its.png',
                         href = "https://felix-its.uz/",
                         name = "Ishlab chiqaruvchi"
                       }: AuthorProps) => {

  const {mode} = useThemeMode()
  const calculatedMode = mode === 'system' ? systemMode : mode

  return (
      <div className={"text-center"}>
        <a target={"_blank"} title={name} href={href}>
          <img className={"w-50px w-md-50 w-xl-75px"} alt={name}
               src={toAbsoluteUrl(calculatedMode === "dark" ? "/media/features-logos/felix-its-light.png" : imagePath)}/>
        </a>
      </div>
  )
}
